import ConversationTopicType from '@/models/ConversationTopics/ConversationTopicType';

export default class CreateconversationTopicRequest  {
	name = '';  
	type: ConversationTopicType = ConversationTopicType.Central;
    isPublic = false;
	isEnabled = true;
	avatar = '';
	branchId = '';
	deskId = '';
	businessHoursId = '';
	isBusinessHoursNotificationEnabled = false;
	businessHoursGroupId = '';
	isOutOfHoursNotificationEnabled = false;
	outOfHoursGroupId = '';
	offlineMessage = '';
}